import React, { FC } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { lighten } from "@mui/material/styles";
import { sideWeights } from "../../utils/vesselWeightHelpers";
import SideWeightIndicator, { Side } from "./SideWeightDistribution";
import VesselTiltFrontProfile from "./VesselTiltFrontProfile";
import { Vessel } from "../../../types/Vessel";
import { useTranslation } from 'react-i18next';

interface Props {
  vessel: Vessel;
  containerWeights: number[];
  containers?: any[];
  terminalCall?: any;
}

const WeightOverBeam: FC<Props> = ({ vessel, containerWeights, containers = [], terminalCall }) => {
  const { t } = useTranslation();
  const borderColor = `1px solid ${lighten("#343A40", 0.7)}`;
  const { port, starboard } = sideWeights(containerWeights);

  return (
    <Box component={Paper} border={borderColor} mb={2}>
      <Typography variant="subtitle1" className="vessel-stability-title">
        {t("weightOverBeam")}
      </Typography>

      <Grid item className="weight-over-beam-content-wrapper" padding="10px">
         <Grid
          className="weight-over-beam-sides weight-over-beam-sides--port"
          item
        >
          {t("portInitial")}
        </Grid>
        <Grid className="weight-over-beam-content" item>
          <Grid
            className="weight-over-beam-content-tonnage weight-over-beam-sb"
            item
          >
            {[...containerWeights].reverse().map((w, idx) => (
              <Grid
                className="weight-over-beam-content-tonnage-per-row"
                item
                key={idx}
              >
                {(w / 1000).toFixed(0)}T
              </Grid>
            ))}
          </Grid>

          {containerWeights.length === 4 && (
            <Grid className="weight-over-beam-content-tonnage-division" item>
              <Grid className="weight-over-beam-content-tonnage-item" item>
                {port}T
              </Grid>
              <Grid className="weight-over-beam-content-tonnage-item" item>
                {starboard}T
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid
          className="weight-over-beam-sides weight-over-beam-sides--starboard"
          item
        >
          {t("starboardInitial")}
        </Grid>
      </Grid>
      <VesselTiltFrontProfile vessel={vessel} containers={containers} terminalCall={terminalCall} />
    </Box>
  );
};

export default WeightOverBeam;
